
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipNavy as ObiShipNavyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-navy.js';
 
 
 

 
 export const ObiShipNavy = createComponent({
   react: React,
   tagName: 'obi-ship-navy',
   elementClass: ObiShipNavyElement,
   events: {
     
   }
  });
 
 